import { message, notification, Upload } from "antd"
import axios from "axios"
import moment, { Moment } from "moment"

//备案系统接口地址
export const AXIOS_IP = window.location.origin +  `/supervise_proxy/wuxi/admin-api`

// export const AXIOS_IP = "http://192.168.111.7:9528/wuxi/admin-api"

// export const AXIOS_IP = "http://36.212.6.254:168/supervise_proxy/wuxi/admin-api"

// 校医务室 饮用水接口地址

// export const AXIOS_IP_WATER = "http://192.168.111.7:9528/jiangsu/admin-api" 

export const AXIOS_IP_WATER = window.location.origin +  `/supervise_proxy/jiangsu/admin-api`

export const acceptImgTypes = '.png,.tiff,.jpg,.jpeg,bmp,.webp'

export const SUPPORTED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
  "image/bmp",
  "image/tiff",
]

export const SUPPORTED_DOC_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
]

export const SUPPORTED_ALL_TYPES = [...SUPPORTED_IMAGE_TYPES, ...SUPPORTED_DOC_TYPES]

// 通用验证函数
export const beforeUploadALL = (
  file: File, 
  urls: string[] = [], 
  maxCount = 3,
  allowedTypes = SUPPORTED_ALL_TYPES,
  maxSizeMB = 10
) => {
  // 检查数量
  if (urls.length >= maxCount) {
    message.error(`最多只能上传${maxCount}个文件!`)
    return false
  }

  // 检查类型
  if (!allowedTypes.includes(file.type)) {
    message.error("不支持的文件格式!")
    return false
  }

  // 检查大小
  const isSizeValid = file.size / 1024 / 1024 < maxSizeMB
  if (!isSizeValid) {
    message.error(`文件大小必须小于 ${maxSizeMB}MB!`)
    return false
  }

  return isSizeValid
}


// 处理图片上传前操作
export const beforeUpload = (file: File, urls: [], maxCount = 3) => {
  if (urls.length >= maxCount) {
    message.error(`最多只能上传${maxCount}张图片!`)
    return false
  }
  if (!SUPPORTED_IMAGE_TYPES.includes(file.type)) {
    message.error(`不支持的图片格式!`)
    return false
  }
  const isLt2M = file.size / 1024 / 1024 < 10
  if (!isLt2M) {
    message.error("图片大小必须小于 10MB!")
  }
  return isLt2M
}

// 处理文件上传前操作
export const beforeUploadFile = (file: File, urls: [], maxCount = 3) => {
  if (urls.length >= maxCount) {
    message.error(`最多只能上传${maxCount}个文件!`)
    return false // 阻止上传
  }
  const isWord =
    file.type === "application/msword" ||
    file.type ===
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  const isPdf = file.type === "application/pdf"

  if (!isPdf) {
    message.error("仅PDF格式文件!")
    return false
  }
  const isLt2M = file.size / 1024 / 1024 < 10
  if (!isLt2M) {
    message.error("文件大小必须小于 10MB!")
  }
  return isLt2M
}

// 自定义上传实现
export const customRequest = async (
    { file, onSuccess, onError, onProgress }: any,
    AXIOS_IP: string,
    callback?: (data: any) => void
  ) => {
    const formData = new FormData()
    formData.append("file", file)
    formData.append("name", file.name)
    try {
      // 使用axios发送请求
      const response = await axios.post(
        `${AXIOS_IP}/infra/file/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            onProgress({ percent })
          },
        }
      )
      if (response.data) {
        const data = response.data
        callback && callback(data)
      }
      onSuccess(response.data)
      message.success(`上传成功`)
    } catch (error) {
      message.error(`上传失败`)
    }
  }

  //文件下载
export const downloadFile = (v: any, token: string, fileTag: string) => {
    axios({
      url: `${AXIOS_IP}/infra/file/downloadFile/${v.fileConfigId}/${v.filePath}`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": token,
      },
      withCredentials: false,
      method: "GET",
    }).then((res: any) => {
      const link = document.createElement('a');
      link.href = `data:${v.fileType};base64,${res.data}`
      link.download = `${v.fileName}.${fileTag}`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }



// 备案类型
export enum FillingType {
  YZBA = '1', //义诊备案
  ZYTF = '2', //中医贴敷备案
  DJDP = '3', //代煎代配管理
  ZYTSLF = '4', //中医特色疗法管理
  CTYX = '5', // 中医传统医学传承
  ZYZC = '6', // 中医专长医学传承
  WCTJ = '7', //外出体检备案
  KJYW = '8', //抗菌药物供应目录备案
  KZLYW = '9', //抗肿瘤药物分级管理目录备案
  YLMR = '10', //医疗美容项目备案
  SSJSS = '11', //三四级手术目录报备
  TJXM = '12', //体检项目备案
}

export const Fillings = [
  FillingType.YZBA,
  FillingType.ZYTF,
  FillingType.DJDP,
  FillingType.ZYTSLF,
  FillingType.CTYX,
  FillingType.TJXM,
  FillingType.WCTJ,
  FillingType.KJYW,
  FillingType.KZLYW,
  FillingType.YLMR,
  FillingType.SSJSS,
]

//生成id
export const generateTempId = () => {
  return `${Date.now()}_${Math.random().toString(36).slice(2, 11)}`
}

export const mapType = (data: []) => {
  const list = data || []
  return list.map((item: any) => {
    return {
      value: Number(item.dicValue),
      label: item.dicLabel,
    }
  })
}

//查找重复数据
interface ArrayItem {
  finallyId?: string | number | null;
  procedureName?: string;
  [key: string]: any;
}

//根据finallyId重复数据过滤
export const findDuplicateFinallyIds = (arr: ArrayItem[]): string[] => {
  const idGroups: Record<string, string[]> = {};
  const idCounts: Record<string, number> = {};
  
  // 1. 统计每个 finallyId 的出现次数
  for (let i = 0; i < arr.length; i++) {
    const id = arr[i].finallyId;
    if (id != null && id !== '') {
      const idStr = String(id);
      idCounts[idStr] = (idCounts[idStr] || 0) + 1;
    }
  }
  
  // 2. 收集重复 finallyId 对应的 procedureName
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    const id = item.finallyId;
    const name = item.procedureName;
    
    if (id != null && id !== '' && name) {
      const idStr = String(id);
      
      // 只处理重复的 finallyId
      if (idCounts[idStr] > 1) {
        if (!idGroups[idStr]) {
          idGroups[idStr] = [];
        }
        
        // 避免重复添加相同的 procedureName
        if (idGroups[idStr].indexOf(name) === -1) {
          idGroups[idStr].push(name);
        }
      }
    }
  }
  
  // 3. 生成拼接字符串
  const result: string[] = [];
  const groupKeys = Object.keys(idGroups);
  
  for (let i = 0; i < groupKeys.length; i++) {
    const names = idGroups[groupKeys[i]];
    if (names.length > 0) {
      result.push(names.join('、'));
    }
  }
  
  return result;
}

// 时间转换
// 定义类型
type Primitive = string | number | boolean | null | undefined;
type MomentConvertible = Moment | Date | string | number;
interface AnyObject {
  [key: string]: any;
}
type ConvertibleValue = Primitive | MomentConvertible | AnyObject | AnyObject[];

export const convertMomentObjects = (
  obj: ConvertibleValue, 
  format = 'YYYY-MM-DD'
): ConvertibleValue => {
  // 处理基本类型
  if (obj === null || obj === undefined || typeof obj !== 'object') {
    return obj;
  }

  // 处理 Moment 对象
  if (moment.isMoment(obj)) {
    return (obj as Moment).format(format);
  }

  // 处理 Date 对象（可选：如果你也想转换原生 Date 对象）
  if (obj instanceof Date) {
    return moment(obj).format(format);
  }

  // 处理数组
  if (Array.isArray(obj)) {
    return obj.map(item => convertMomentObjects(item, format));
  }

  // 处理普通对象
  const result: AnyObject = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[key] = convertMomentObjects(obj[key], format);
    }
  }
  
  return result;
}

//导出pdf
export const download = (data: Blob, fileName: string, mineType: string) => {
  const blob = new Blob([data], { type: mineType })
  window.URL = window.URL || window.webkitURL
  const href = URL.createObjectURL(blob)
  const downA = document.createElement('a')
  downA.href = href
  downA.download = fileName
  downA.click()
  // 销毁超连接
  window.URL.revokeObjectURL(href)
}

interface ExportPdfParams {
  token: string
  path: string
  fileName: string
  data: any
  callback: (type: boolean) => void
}

export const exportPdf = ({
  token,
  path,
  fileName,
  data,
  callback,
}: ExportPdfParams) => { 
  callback && callback(true)
  axios({
    url: `${AXIOS_IP}${path}`,
    headers: {
      "Content-Type": "application/json",
      "His-Auth": token,
    },
    withCredentials: false,
    responseType: 'blob',
    method: "POST",
    data
  }).then((res) => { 
    download(res.data as unknown as Blob, fileName, 'application/pdf')
    callback && callback(false)
    notification.success({
      message: '操作成功',
      duration: 3,
    })
  })
}